import React from 'react'
import FullLayout from '../components/FullLayout'

const Favorites = () => {
    return (
        <>
            <FullLayout>
                <div className="favorites">
                    <div className="row">
                        <div className="col-lg-3 px-1 px-lg-2 col-6">
                            <div className="cards">
                                <img src="/assets/image/favorite.png" className='w-100' alt="" />
                                <div className="icon icon-heart"></div>
                            </div>
                        </div>
                        <div className="col-lg-3 px-1 px-lg-2 col-6">
                            <div className="cards">
                                <img src="/assets/image/favorite.png" className='w-100' alt="" />
                                <div className="icon icon-heart"></div>
                            </div>
                        </div>
                        <div className="col-lg-3 px-1 px-lg-2 col-6">
                            <div className="cards">
                                <img src="/assets/image/favorite.png" className='w-100' alt="" />
                                <div className="icon icon-heart"></div>
                            </div>
                        </div>
                        <div className="col-lg-3 px-1 px-lg-2 col-6">
                            <div className="cards">
                                <img src="/assets/image/favorite.png" className='w-100' alt="" />
                                <div className="icon icon-heart"></div>
                            </div>
                        </div>
                        <div className="col-lg-3 px-1 px-lg-2 col-6">
                            <div className="cards">
                                <img src="/assets/image/favorite.png" className='w-100' alt="" />
                                <div className="icon icon-heart"></div>
                            </div>
                        </div>
                        <div className="col-lg-3 px-1 px-lg-2 col-6">
                            <div className="cards">
                                <img src="/assets/image/favorite.png" className='w-100' alt="" />
                                <div className="icon icon-heart"></div>
                            </div>
                        </div>
                        <div className="col-lg-3 px-1 px-lg-2 col-6">
                            <div className="cards">
                                <img src="/assets/image/favorite.png" className='w-100' alt="" />
                                <div className="icon icon-heart"></div>
                            </div>
                        </div>
                        <div className="col-lg-3 px-1 px-lg-2 col-6">
                            <div className="cards">
                                <img src="/assets/image/favorite.png" className='w-100' alt="" />
                                <div className="icon icon-heart"></div>
                            </div>
                        </div>
                        <div className="col-lg-3 px-1 px-lg-2 col-6">
                            <div className="cards">
                                <img src="/assets/image/favorite.png" className='w-100' alt="" />
                                <div className="icon icon-heart"></div>
                            </div>
                        </div>
                        <div className="col-lg-3 px-1 px-lg-2 col-6">
                            <div className="cards">
                                <img src="/assets/image/favorite.png" className='w-100' alt="" />
                                <div className="icon icon-heart"></div>
                            </div>
                        </div>
                        <div className="col-lg-3 px-1 px-lg-2 col-6">
                            <div className="cards">
                                <img src="/assets/image/favorite.png" className='w-100' alt="" />
                                <div className="icon icon-heart"></div>
                            </div>
                        </div>
                        <div className="col-lg-3 px-1 px-lg-2 col-6">
                            <div className="cards">
                                <img src="/assets/image/favorite.png" className='w-100' alt="" />
                                <div className="icon icon-heart"></div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 mt-lg-5 mt-4 d-flex align-items-center justify-content-between flex-column">
                            <button className="btn first">Товары</button>
                            <span><img src="/assets/image/pagination.png" className='w-100' alt="" /></span>
                            <button className="btn mobile">Товары</button>
                            <button className="btn pinks">Бренды</button>
                        </div>
                    </div>
                </div>
            </FullLayout>
        </>
    )
}

export default Favorites